export const TEST = 'TEST';
export const SET_MOBILE_NAV_STATUS = 'SET_MOBILE_NAV_STATUS';

export const GET_USER_DATA_STARTED = 'GET_USER_DATA_STARTED';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';

export const LOGOUT_STARTED = 'LOGOUT_STARTED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const GET_WALLETS_STARTED = 'GET_WALLETS_STARTED';
export const GET_WALLETS_SUCCESS = 'GET_WALLETS_SUCCESS';
export const GET_WALLETS_FAILURE = 'GET_WALLETS_FAILURE';

export const SET_CABINET_WALLET_RECEIVE_MODAL_STATUS = 'SET_CABINET_WALLET_RECEIVE_MODAL_STATUS';
export const SET_CABINET_WALLET_SEND_MODAL_STATUS = 'SET_CABINET_WALLET_SEND_MODAL_STATUS';

export const GET_RECEIVE_CURRENCY_STARTED = 'GET_RECEIVE_CURRENCY_STARTED';
export const GET_RECEIVE_CURRENCY_SUCCESS = 'GET_RECEIVE_CURRENCY_SUCCESS';
export const GET_RECEIVE_CURRENCY_FAILURE = 'GET_RECEIVE_CURRENCY_FAILURE';

export const GET_RECEIVE_NETWORK_STARTED = 'GET_RECEIVE_NETWORK_STARTED';
export const GET_RECEIVE_NETWORK_SUCCESS = 'GET_RECEIVE_NETWORK_SUCCESS';
export const GET_RECEIVE_NETWORK_FAILURE = 'GET_RECEIVE_NETWORK_FAILURE';


export const GET_RECEIVE_ASSET_STARTED = 'GET_RECEIVE_ASSET_STARTED';
export const GET_RECEIVE_ASSET_SUCCESS = 'GET_RECEIVE_ASSET_SUCCESS';
export const GET_RECEIVE_ASSET_FAILURE = 'GET_RECEIVE_ASSET_FAILURE';

export const GET_SEND_CURRENCY_STARTED = 'GET_SEND_CURRENCY_STARTED';
export const GET_SEND_CURRENCY_SUCCESS = 'GET_SEND_CURRENCY_SUCCESS';
export const GET_SEND_CURRENCY_FAILURE = 'GET_SEND_CURRENCY_FAILURE';

export const GET_SEND_NETWORK_STARTED = 'GET_SEND_NETWORK_STARTED';
export const GET_SEND_NETWORK_SUCCESS = 'GET_SEND_NETWORK_SUCCESS';
export const GET_SEND_NETWORK_FAILURE = 'GET_SEND_NETWORK_FAILURE';


export const GET_SEND_ASSET_STARTED = 'GET_SEND_ASSET_STARTED';
export const GET_SEND_ASSET_SUCCESS = 'GET_SEND_ASSET_SUCCESS';
export const GET_SEND_ASSET_FAILURE = 'GET_SEND_ASSET_FAILURE';

export const GET_SEND_FEE_STARTED = 'GET_SEND_FEE_STARTED';
export const GET_SEND_FEE_SUCCESS = 'GET_SEND_FEE_SUCCESS';
export const GET_SEND_FEE_FAILURE = 'GET_SEND_FEE_FAILURE';

export const GET_WALLET_HISTORY_STARTED = 'GET_WALLET_HISTORY_STARTED';
export const GET_WALLET_HISTORY_SUCCESS = 'GET_WALLET_HISTORY_SUCCESS';
export const GET_WALLET_HISTORY_FAILURE = 'GET_WALLET_HISTORY_FAILURE';

export const GET_MARKET_CHARTS_STARTED = 'GET_MARKET_CHARTS_STARTED';
export const GET_MARKET_CHARTS_SUCCESS = 'GET_MARKET_CHARTS_SUCCESS';
export const GET_MARKET_CHARTS_FAILURE = 'GET_MARKET_CHARTS_FAILURE';

export const GET_PARTNERS_MAIN_DATA_STARTED = 'GET_PARTNERS_MAIN_DATA_STARTED';
export const GET_PARTNERS_MAIN_DATA_SUCCESS = 'GET_PARTNERS_MAIN_DATA_SUCCESS';
export const GET_PARTNERS_MAIN_DATA_FAILURE = 'GET_PARTNERS_MAIN_DATA_FAILURE';

export const GET_ALL_PARTNERS_STARTED = 'GET_ALL_PARTNERS_STARTED';
export const GET_ALL_PARTNERS_SUCCESS = 'GET_ALL_PARTNERS_SUCCESS';
export const GET_ALL_PARTNERS_FAILURE = 'GET_ALL_PARTNERS_FAILURE';

export const EXCHANGE_POINTS_STARTED = 'EXCHANGE_POINTS_STARTED';
export const EXCHANGE_POINTS_SUCCESS = 'EXCHANGE_POINTS_SUCCESS';
export const EXCHANGE_POINTS_FAILURE = 'EXCHANGE_POINTS_FAILURE';

export const GET_PARTNERS_CARD_STARTED = 'GET_PARTNERS_CARD_STARTED';
export const GET_PARTNERS_CARD_SUCCESS = 'GET_PARTNERS_CARD_SUCCESS';
export const GET_PARTNERS_CARD_FAILURE = 'GET_PARTNERS_CARD_FAILURE';

export const SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS = 'SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS';

export const SET_PARTNERS_CARD_SETTINGS_STARTED = 'SET_PARTNERS_CARD_SETTINGS_STARTED';
export const SET_PARTNERS_CARD_SETTINGS_SUCCESS = 'SET_PARTNERS_CARD_SETTINGS_SUCCESS';
export const SET_PARTNERS_CARD_SETTINGS_FAILURE = 'SET_PARTNERS_CARD_SETTINGS_FAILURE';

export const SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS = 'SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS';

export const GET_SUBSCRIBE_STARTED = 'GET_SUBSCRIBE_STARTED';
export const GET_SUBSCRIBE_SUCCESS = 'GET_SUBSCRIBE_SUCCESS';
export const GET_SUBSCRIBE_FAILURE = 'GET_SUBSCRIBE_FAILURE';

export const SET_SUBSCRIBE_STATUS = 'SET_SUBSCRIBE_STATUS';

export const SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS = 'SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS';
export const SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS = 'SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS';
export const SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS = 'SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS';

export const SET_PROFILE_PERSONAL_INFORMATION_STARTED = 'SET_PROFILE_PERSONAL_INFORMATION_STARTED';
export const SET_PROFILE_PERSONAL_INFORMATION_SUCCESS = 'SET_PROFILE_PERSONAL_INFORMATION_SUCCESS';
export const SET_PROFILE_PERSONAL_INFORMATION_FAILURE = 'SET_PROFILE_PERSONAL_INFORMATION_FAILURE';

export const GET_PROFILE_MAIN_DATA_STARTED = 'GET_PROFILE_MAIN_DATA_STARTED';
export const GET_PROFILE_MAIN_DATA_SUCCESS = 'GET_PROFILE_MAIN_DATA_SUCCESS';
export const GET_PROFILE_MAIN_DATA_FAILURE = 'GET_PROFILE_MAIN_DATA_FAILURE';

export const SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS = 'SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS';

export const PROFILE_CHANGE_PASSWORD_STARTED = 'PROFILE_CHANGE_PASSWORD_STARTED';
export const PROFILE_CHANGE_PASSWORD_SUCCESS = 'PROFILE_CHANGE_PASSWORD_SUCCESS';
export const PROFILE_CHANGE_PASSWORD_FAILURE = 'PROFILE_CHANGE_PASSWORD_FAILURE';

export const SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS = 'SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS';

export const GET_PROFILE_OPTION_2FA_STARTED = 'GET_PROFILE_OPTION_2FA_STARTED';
export const GET_PROFILE_OPTION_2FA_SUCCESS = 'GET_PROFILE_OPTION_2FA_SUCCESS';
export const GET_PROFILE_OPTION_2FA_FAILURE = 'GET_PROFILE_OPTION_2FA_FAILURE';

export const SET_PROFILE_OPTION_2FA_STARTED = 'SET_PROFILE_OPTION_2FA_STARTED';
export const SET_PROFILE_OPTION_2FA_SUCCESS = 'SET_PROFILE_OPTION_2FA_SUCCESS';
export const SET_PROFILE_OPTION_2FA_FAILURE = 'SET_PROFILE_OPTION_2FA_FAILURE';

export const SET_GOOGLE_CODE_2FA_STARTED = 'SET_GOOGLE_CODE_2FA_STARTED';
export const SET_GOOGLE_CODE_2FA_SUCCESS = 'SET_GOOGLE_CODE_2FA_SUCCESS';
export const SET_GOOGLE_CODE_2FA_FAILURE = 'SET_GOOGLE_CODE_2FA_FAILURE';

export const SET_2FA_SETTINGS_STARTED = 'SET_2FA_SETTINGS_STARTED';
export const SET_2FA_SETTINGS_SUCCESS = 'SET_2FA_SETTINGS_SUCCESS';
export const SET_2FA_SETTINGS_FAILURE = 'SET_2FA_SETTINGS_FAILURE';

export const SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS = 'SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS';

export const GET_DEPOSIT_ALL_STARTED = 'GET_DEPOSIT_ALL_STARTED';
export const GET_DEPOSIT_ALL_SUCCESS = 'GET_DEPOSIT_ALL_SUCCESS';
export const GET_DEPOSIT_ALL_FAILURE = 'GET_DEPOSIT_ALL_FAILURE';

export const GET_DEPOSIT_CURRENCY_STARTED = 'GET_DEPOSIT_CURRENCY_STARTED';
export const GET_DEPOSIT_CURRENCY_SUCCESS = 'GET_DEPOSIT_CURRENCY_SUCCESS';
export const GET_DEPOSIT_CURRENCY_FAILURE = 'GET_DEPOSIT_CURRENCY_FAILURE';

export const GET_DEPOSIT_NETWORK_STARTED = 'GET_DEPOSIT_NETWORK_STARTED';
export const GET_DEPOSIT_NETWORK_SUCCESS = 'GET_DEPOSIT_NETWORK_SUCCESS';
export const GET_DEPOSIT_NETWORK_FAILURE = 'GET_DEPOSIT_NETWORK_FAILURE';

export const GET_DEPOSIT_ASSET_STARTED = 'GET_DEPOSIT_ASSET_STARTED';
export const GET_DEPOSIT_ASSET_SUCCESS = 'GET_DEPOSIT_ASSET_SUCCESS';
export const GET_DEPOSIT_ASSET_FAILURE = 'GET_DEPOSIT_ASSET_FAILURE';

export const SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS = 'SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS';

export const DISABLE_2FA_STARTED = 'DISABLE_2FA_STARTED';
export const DISABLE_2FA_SUCCESS = 'DISABLE_2FA_SUCCESS';
export const DISABLE_2FA_FAILURE = 'DISABLE_2FA_FAILURE';

export const GET_DEPOSIT_FEE_STARTED = 'GET_DEPOSIT_FEE_STARTED';
export const GET_DEPOSIT_FEE_SUCCESS = 'GET_DEPOSIT_FEE_SUCCESS';
export const GET_DEPOSIT_FEE_FAILURE = 'GET_DEPOSIT_FEE_FAILURE';

export const OPEN_DEPOSIT_STARTED = 'OPEN_DEPOSIT_STARTED';
export const OPEN_DEPOSIT_SUCCESS = 'OPEN_DEPOSIT_SUCCESS';
export const OPEN_DEPOSIT_FAILURE = 'OPEN_DEPOSIT_FAILURE';

export const GET_TWO_FACTOR_OPTIONS_STARTED = 'GET_TWO_FACTOR_OPTIONS_STARTED';
export const GET_TWO_FACTOR_OPTIONS_SUCCESS = 'GET_TWO_FACTOR_OPTIONS_SUCCESS';
export const GET_TWO_FACTOR_OPTIONS_FAILURE = 'GET_TWO_FACTOR_OPTIONS_FAILURE';

export const SEND_CRYPTO_STARTED = 'SEND_CRYPTO_STARTED';
export const SEND_CRYPTO_SUCCESS = 'SEND_CRYPTO_SUCCESS';
export const SEND_CRYPTO_FAILURE = 'SEND_CRYPTO_FAILURE';

export const UPDATE_USER_AVATAR_STARTED = 'UPDATE_USER_AVATAR_STARTED';
export const UPDATE_USER_AVATAR_SUCCESS = 'UPDATE_USER_AVATAR_SUCCESS';
export const UPDATE_USER_AVATAR_FAILURE = 'UPDATE_USER_AVATAR_FAILURE';

export const GET_PARTNERS_CONVERT_HISTORY_STARTED = 'GET_PARTNERS_CONVERT_HISTORY_STARTED';
export const GET_PARTNERS_CONVERT_HISTORY_SUCCESS = 'GET_PARTNERS_CONVERT_HISTORY_SUCCESS';
export const GET_PARTNERS_CONVERT_HISTORY_FAILURE = 'GET_PARTNERS_CONVERT_HISTORY_FAILURE';

export const HIDE_BALANCE_STARTED = 'HIDE_BALANCE_STARTED';
export const HIDE_BALANCE_SUCCESS = 'HIDE_BALANCE_SUCCESS';
export const HIDE_BALANCE_FAILURE = 'HIDE_BALANCE_FAILURE';

export const REFRESH_WALLET_HISTORY = 'REFRESH_WALLET_HISTORY';

